<div class="relative flex min-h-screen items-center justify-center overflow-hidden bg-[#fafafa] px-6 py-12">
  <div class="relative w-full max-w-xl rounded-3xl border border-slate-200 bg-white p-8 text-center shadow-[0_20px_60px_-20px_rgba(15,23,42,0.2)]">
    <div class="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-2xl bg-slate-900 text-white shadow-lg">
      <span class="text-2xl font-semibold">!</span>
    </div>
    <h1 class="text-3xl font-semibold text-slate-900">Unauthorized</h1>
    <p class="mt-3 text-sm text-slate-600">
      Your account does not have access to this area. Please contact an administrator if you believe this is a mistake.
    </p>
    <div class="mt-8 flex flex-wrap justify-center gap-3">
      <button
        type="button"
        class="inline-flex items-center justify-center rounded-full bg-slate-900 px-5 py-2 text-sm font-semibold text-white transition hover:bg-slate-800"
        (click)="signOut()"
      >
        Logout
      </button>
    </div>
  </div>
</div>
